import "./featureOverlay.scss";
import { ReactComponent as IconClose } from "static/icons/close.svg";
import classNames from "classnames";
import { MouseEvent, useRef } from "react";
import * as utils from "shell/app/app.utils";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import ButtonSolid, {
  ButtonSolidType,
} from "components/buttonSolid/buttonSolid";
import { iconGridItemData } from "components/iconGrid/iconGridItem";
import parse from "html-react-parser";

interface featureOverlayProps {
  items: iconGridItemData[];
  button: ButtonSolidType;
}

const FeatureOverlay: React.FC<featureOverlayProps> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [feature, setFeature] = useState<string>("");
  const [featureIndex, setFeatureIndex] = useState<number>(0);
  const history = useHistory();
  const contentAr = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const onHistoryChange = () => {
      const hash = history.location.hash.replace("#", "");
      if (!!hash) {
        setFeature(hash);
      }
      setOpen(!!hash.length);
    };
    return history.listen(onHistoryChange);
  }, [history]);

  useEffect(() => {
    if (feature.length) {
      let _featureIndex = 0;
      props.items.forEach((item: iconGridItemData, key: number) => {
        if (item.id === feature) {
          _featureIndex = key;
        }
      });
      setFeatureIndex(_featureIndex);
    }
  }, [feature, props.items]);

  const handleArrowClick = (e: MouseEvent) => {
    const dir = e.currentTarget.getAttribute("data-dir");
    const _newIndex = featureIndex + parseInt(dir || "");
    const _newFeature = props.items[_newIndex];
    history.push("#" + _newFeature.id);
  };

  //
  return (
    <div className={classNames("feature-overlay", { "is-open": !!open })}>
      <div className="feature-overlay__bg" />

      <div className="feature-overlay__wrapper wrapper">
        <div className="feature-overlay__inner">
          <img
            className="feature-overlay__background"
            src={utils.assetPath("/images/background.jpg")}
            alt=""
          />
          <IconClose
            className="feature-overlay__close"
            onClick={() => history.push("")}
          />
          <div className="feature-overlay__icons">
            {props.items.map((item, key) => (
              <img
                src={utils.assetPath(item.iconGlow)}
                className={classNames("feature-overlay__icon", {
                  "is-visible": item.id === feature,
                })}
                key={key}
                alt=""
              />
            ))}
          </div>

          <div className="feature-overlay__content">
            {props.items.map((item, key) => (
              <div
                className={classNames("feature-overlay__contents", {
                  "is-visible": item.id === feature,
                })}
                ref={(ref) => (contentAr.current[key] = ref)}
                key={key}
              >
                <h6 className="feature-overlay__contents-overline">
                  {item.overline}
                </h6>
                <p className="feature-overlay__contents-copy">{parse(item.copy)}</p>
              </div>
            ))}
          </div>

          <div className="feature-overlay__navigation">
            <button
              type="button"
              className="feature-overlay__navigation-arrow is-left"
              onClick={handleArrowClick}
              data-dir="-1"
              disabled={featureIndex === 0}
            >
              <img src={utils.assetPath("/icons/arrow-left.svg")} alt="" />
            </button>
            <button
              type="button"
              className="feature-overlay__navigation-arrow is-right"
              onClick={handleArrowClick}
              data-dir="1"
              disabled={featureIndex === props.items.length - 1}
            >
              <img src={utils.assetPath("/icons/arrow-right.svg")} alt="" />
            </button>
          </div>

          {!!props.items[featureIndex].iconFooter && (
            <div className="feature-overlay__footer">
              <div
                className={classNames(
                  "feature-overlay__footer-icon",
                  `feature-overlay__footer-icon--${props.items[featureIndex].id}`,
                  {
                    "is-visible": props.items[featureIndex].id === feature,
                  }
                )}
              >
                <img src={utils.assetPath(props.items[featureIndex].iconFooter)} alt="" />;
              </div>
            </div>
          )}
        </div>
        <ButtonSolid {...props.button} className="feature-overlay__button" />
      </div>
    </div>
  );
};

export default FeatureOverlay;
